module.exports = __webpack_public_path__ + "img/00233065000187.63af10be.png";